<template>
  <div class="basic">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="基本信息" name="基本信息">
        <div style="height: 100%">
          <span class="title">基本信息</span>
          <!-- <div v-if="showInfoTip">
            请核实【行业类别】、【行业代码】、【管理类别】、【经度/纬度】是否填报完整。
          </div>  -->
          <el-alert
            v-if="showTipInfo.isShow"
            :title="showTipInfo.msg"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
          <div class="basic-com">
            <el-descriptions class="margin-top" :size="size" :column="2" border>
              <template slot="title" v-if="!companyId">
                <el-button size="mini" @click="$refs.uploadFile.visible = true"
                  >导入危废管理计划<i class="el-icon-upload el-icon--right"></i
                ></el-button>
              </template>

              <template slot="extra" v-if="!companyId">
                <el-button size="mini" v-show="!isEdit" @click="edit()"
                  >编辑 <i class="el-icon-edit-outline el-icon--right"></i
                ></el-button>
                <el-button size="mini" v-show="isEdit" @click="isEdit = false"
                  >取消</el-button
                >
                <el-button
                  size="mini"
                  v-show="isEdit"
                  type="success"
                  @click="save()"
                  >保存</el-button
                >
              </template>

              <el-descriptions-item>
                <template slot="label"> 企业名称 </template>
                <span v-if="!isEdit">{{ companyData.name }}</span>
                <el-input v-else :disabled="true" v-model="companyData.name" />
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label"> 统一社会信用代码 </template>
                <span v-if="!isEdit">{{
                  companyData.uniformSocialCreditCode
                }}</span>
                <el-input
                  v-else
                  :disabled="true"
                  v-model="companyData.uniformSocialCreditCode"
                />
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 注册地址 </template>
                <span v-if="!isEdit">{{ companyData.addr }}</span>
                <el-input v-else v-model="companyData.addr" />
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 行业类别 </template>
                <span v-if="!isEdit">{{ industry2017Names }}</span>
                <el-cascader
                  v-else
                  placeholder="请选择行业类别"
                  ref="industryCas"
                  style="width: 100%"
                  collapse-tags
                  v-model="industry2017s"
                  :props="industriesProps"
                  :options="industries"
                  filterable
                  @change="changeIndustry"
                >
                  <!-- <template slot-scope="{ data }">
        <span>{{ data.industryName }}</span>
      </template> -->
                </el-cascader>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 生产经营场所 </template>
                <span v-if="!isEdit">{{ companyData.productionAddress }}</span>
                <el-input v-else v-model="companyData.productionAddress" />
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 行业代码 </template>
                <span v-if="!isEdit">{{ companyData.industryCode }}</span>
                <el-input
                  v-else
                  :disabled="true"
                  v-model="companyData.industryCode"
                />
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 危废管理联系人 </template>
                <span v-if="!isEdit">{{ companyData.wasteContact }}</span>
                <el-input v-else v-model="companyData.wasteContact" />
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 联系电话 </template>
                <span v-if="!isEdit">{{ companyData.mobile }}</span>
                <el-input v-else v-model="companyData.mobile" />
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <span v-show="isEdit" style="color: #f56c6c">*</span>
                  上年度危险废物产生量（吨）
                </template>
                <span v-if="!isEdit">{{ companyData.lastYearDWweight }}</span>
                <el-input v-else v-model="companyData.lastYearDWweight" />
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <span v-show="isEdit" style="color: #f56c6c">*</span>
                  上年度工业产值（万元）
                </template>
                <span v-if="!isEdit">{{ companyData.lastYearValue }}</span>
                <el-input v-else v-model="companyData.lastYearValue" />
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 管理类别 </template>
                <el-select
                  :disabled="!isEdit"
                  style="width: 100%"
                  v-model="companyData.manageCategory"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in manageCategory"
                    :key="item.Key"
                    :label="item.Value"
                    :value="item.Key"
                  >
                  </el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 是否提交本年度危废管理计划 </template>
                <el-select
                  :disabled="!isEdit"
                  style="width: 100%"
                  v-model="companyData.isSubmitYearPlan"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in yesOrNoOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <span v-show="isEdit" style="color: #f56c6c">*</span> 所属辖区
                </template>
                <el-select
                  :disabled="!isEdit"
                  style="width: 100%"
                  v-model="companyData.jurisdiction"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in jurisdiction"
                    :key="item.Key"
                    :label="item.Value"
                    :value="item.Key"
                  >
                  </el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 经度/纬度 </template>
                <div style="display: flex">
                  <el-input
                    v-model="companyData.lng"
                    :disabled="!isEdit"
                    style="margin-right: 14px"
                  />
                  <el-input
                    v-model="companyData.lat"
                    :disabled="!isEdit"
                    style="margin-right: 14px"
                  />
                  <el-button v-if="isEdit" type="text" @click="openChose"
                    >选择定位</el-button
                  >
                  <el-button v-else type="text" @click="showMap"
                    >查看位置</el-button
                  >
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="危废产生清单" name="危废产生清单">
        <div style="height: 100%">
          <span class="title">危废产生清单</span>
          <div class="basic-list">
            <div class="operate-btns" v-auth="'Company'">
              <!-- <el-button size="mini" @click="addList()">添加清单</el-button> -->
            </div>
            <el-table
              :header-cell-style="{
                background: '#f5f5f5',
              }"
              :data="wfList"
              height="100%"
              border
              style="width: 100%"
            >
              <el-table-column
                align=" center"
                label="序号"
                type="index"
                width="50"
              >
              </el-table-column>
              <el-table-column align="center" prop="name" label="危废名称">
              </el-table-column>
              <el-table-column align="center" prop="type" label="危险废物类别">
              </el-table-column>
              <el-table-column align="center" prop="code" label="危险废物代码">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <el-dialog
          width="500px"
          title="添加危废产生清单"
          :visible.sync="dialogFormVisible"
        >
          <div class="dialog-form">
            <el-form :model="form" :rules="rules" ref="listForm">
              <el-form-item prop="name" label="危废名称">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item prop="type" label="危险废物类别">
                <el-select
                  style="width: 100%"
                  @change="getCodes"
                  v-model="form.type"
                  placeholder="请选择危险废物类别"
                >
                  <el-option
                    v-for="item in types"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="code" label="危险废物代码">
                <el-select
                  style="width: 100%"
                  v-model="form.code"
                  placeholder="请选择危险废物代码"
                  popper-class="new-select"
                >
                  <el-option
                    v-for="item in codes"
                    :key="item.id"
                    :label="item.code + ' ' + item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveList()">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>

    <uploadFile
      :url="$api.dangerWasters.import"
      @getData="getData()"
      ref="uploadFile"
    ></uploadFile>
    <point-choose ref="choose1" :lnglat="lnglat" @ok="chooseOK" />
  </div>
</template>

<script>
import uploadFile from "@/components/uploadFile";
import PointChoose from "@/components/Map/Choose";

export default {
  props: {
    companyId: {
      default: 0,
    },
  },
  components: { uploadFile, PointChoose },
  data() {
    return {
      activeName: "基本信息",
      isEdit: false,
      basicConfig: [
        {
          text: "企业名称",
          field: "name",
          type: "text",
          isEdit: false,
        },
        {
          text: "统一社会信用代码",
          field: "uniformSocialCreditCode",
          type: "text",
          isEdit: false,
        },
        {
          text: "注册地址",
          field: "addr",
          type: "text",
          isEdit: true,
        },
        {
          text: "行业类别",
          field: "industry",
          type: "text",
          isEdit: true,
        },
        {
          text: "生产经营场所",
          field: "productionAddress",
          type: "text",
          isEdit: true,
        },
        {
          text: "行业代码",
          field: "industry",
          type: "text",
          isEdit: true,
        },
        {
          text: "危废管理联系人",
          field: "wasteContact",
          type: "text",
          isEdit: true,
        },
        {
          text: "联系电话",
          field: "mobile",
          type: "text",
          isEdit: true,
        },
        {
          text: "上年度危险废物产生量（吨）",
          field: "mobile",
          type: "text",
          isEdit: true,
        },
        {
          text: "上年度工业产值（万元）",
          field: "mobile",
          type: "text",
          isEdit: true,
        },
        {
          text: "管理类别",
          field: "manageCategory",
          type: "drop",
          dropSource: "",
          isEdit: true,
        },
        {
          text: "是否提交本年度危废管理计划",
          field: "manageCategory",
          type: "text",
          isEdit: false,
        },
      ],
      yesOrNoOptions: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],

      companyData: {
        industry2017s: [],
      },
      industry2017s: [],
      wfList: [],
      dialogFormVisible: false,
      form: {
        name: "",
        type: "",
        code: "",
        id: 0,
      },

      industries: [],
      industriesProps: {
        multiple: true,
        value: "industryCode",
        label: "industryName",
        emitPath: false,
      },
      manageCategory: [], //管理类别
      jurisdiction: [], //所属辖区
      types: [],
      codes: [],

      rules: {
        name: [{ required: true, message: "请输入废物名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择危险废物类别", trigger: "change" },
        ],
        code: [
          { required: true, message: "请选择危险废物代码", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    industry2017Names() {
      return this.companyData.industry2017s
        .map((i) => i.industryName)
        .join("，");
    },
    size() {
      return this.isEdit ? "mini" : "";
    },
    lnglat() {
      return [this.companyData.lng, this.companyData.lat];
    },

    showTipInfo() {
      if (!this.companyData) {
        return { isShow: false, msg: "" };
      }
      if (this.companyId) {
        return { isShow: false, msg: "" };
      }
      const {
        isSubmitYearPlan,
        industry2017s,
        industryCode,
        manageCategory,
        lat,
        lng,
      } = this.companyData;

      const missingFields = [];

      if (!industry2017s || industry2017s.length === 0) {
        missingFields.push("【行业类别】");
      }
      if (!industryCode) {
        missingFields.push("【行业代码】");
      }
      if (!manageCategory) {
        missingFields.push("【管理类别】");
      }
      if (!lat || !lng) {
        missingFields.push("【经度/纬度】");
      }

      const isShow = isSubmitYearPlan && missingFields.length > 0;
      const msg = isShow
        ? `请核实${missingFields.join("、")}是否填报完整。`
        : "";

      return { isShow, msg };
    },
  },
  watch: {
    companyId(val) {
      this.getAllData();
    },
  },
  methods: {
    openChose() {
      this.$refs.choose1.open();
    },
    chooseOK(lnglat) {
      this.companyData.lng = lnglat[0];
      this.companyData.lat = lnglat[1];
    },
    showMap() {
      this.$refs.choose1.detail();
      // this.dialogMapVisible = true
      // this.$refs.map1.addPoint([this.companyData.lng, this.companyData.lat], false)
    },
    getData() {
      let url = this.$api.companies.getUserCompany;
      let params = {};
      if (this.companyId) params = { companyId: this.companyId };
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let { company, wfList, industries, manageCategory, jurisdiction } =
            res.data.data;
          this.industry2017s = company.industry2017s.map((c) => c.industryCode);
          // company.industry = [
          //   "0111",
          //   "0112",
          //   "0113",
          //   "0119"
          // ]
          this.companyData = company;
          this.wfList = wfList;
          this.industries = industries;
          this.manageCategory = manageCategory;
          this.jurisdiction = jurisdiction;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    edit() {
      this.isEdit = true;
    },
    save() {
      let url = this.$api.companies.modifyCompany;
      let nodes = this.$refs.industryCas.getCheckedNodes(true);

      this.companyData.industry2017s = nodes.map((n) => n.data);
      console.log(this.companyData);
      if (!this.companyData.lastYearDWweight) {
        this.$message({
          message: "请输入上年度危险废物产生量",
          type: "error",
        });
        return;
      }
      if (!this.companyData.lastYearValue) {
        this.$message({
          message: "请输入上年度工业产值",
          type: "error",
        });
        return;
      }
      if (!this.companyData.jurisdiction) {
        this.$message({
          message: "请选择所属辖区",
          type: "error",
        });
        return;
      }
      this.$axios
        .post(url, this.companyData, false)
        .then((res) => {
          if (res.data.code === 0) {
            this.isEdit = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addList() {
      this.dialogFormVisible = true;
    },
    saveList() {
      this.$refs.listForm.validate((valid) => {
        if (valid) {
          let url = this.$api.dangerWasters.addDangerWasterList;
          this.$axios
            .post(url, this.form, false)
            .then((res) => {
              if (res.data.code === 0) {
                this.dialogFormVisible = false;
                this.form = {
                  name: "",
                  type: "",
                  code: "",
                  id: 0,
                };
                this.getData();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getTypes() {
      let url = this.$api.dangerWasters.getTypes;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          this.types = res.data.data.types;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    getCodes() {
      this.form.code = "";
      const { types, form } = this;
      const item = types.find((item) => item.name === form.type);
      let url = this.$api.dangerWasters.getCodes + "/" + item.id;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          this.codes = res.data.data.codes;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    changeIndustry(data) {
      // this.companyData.industryCode = data.join(',')
      let nodes = this.$refs.industryCas.getCheckedNodes(true);
      let codes = [];
      nodes.forEach((node) => {
        let { path, value } = node;
        if (data.includes(value)) {
          let l = path.length - 1;
          codes.push(path[0] + path[l]);
        }
      });
      this.companyData.industryCode = codes.join("、");
    },

    getAllData() {
      this.getData();
      this.getTypes();
    },
  },
  mounted() {
    // this.companyId = this.$route.params.companyId;

    this.getAllData();
  },
};
</script>
<style lang="scss" scoped>
.basic {
  height: 100%;

  .el-tabs {
    width: 100%;
    height: 100%;

    /deep/.el-tabs__content {
      height: calc(100% - 55px);

      .el-tab-pane {
        height: 100%;
      }
    }
  }
}

.basic-com {
  height: 100%;
  padding: 10px 50px;
}

/deep/.el-descriptions__header {
  margin-bottom: 5px;
}

.basic-list {
  height: 90%;
  padding: 10px 50px;

  .operate-btns {
    margin-bottom: 5px;
  }
}

.dialog-form {
  padding: 0px 20px;
}

.title {
  font-size: 18px;
  font-weight: bold;
  border-left: 8px solid #1890ff;
  padding-left: 12px;
  color: #000;
}
</style>
<style lang="scss">
.new-select {
  .el-select-dropdown {
    max-width: 500px;
    left: 0 !important;
    box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.1);
  }

  .el-select-dropdown__item {
    display: inline-block;
  }

  .el-select-dropdown__item span {
    display: inline-block;
    min-width: 450px;
    padding-right: 20px;
  }

  .el-select-dropdown__wrap {
    margin-bottom: -20px !important;
    width: 500px;
    overflow: scroll;
  }
}
</style>